import { frontendURL } from "dashboard/helper/URLHelper";
import SkillRoutingView from "./SkillRoutingView.vue";
import RolesView from "./RolesView.vue";
import { ROLES } from "dashboard/constants/permissions.js";

// AC-Group-Patch: Navigation erlaubt (agent+admin); die konkrete Berechtigung erzwingt glue (403).
export const routes = [
  {
    path: frontendURL("accounts/:accountId/skill-routing"),
    name: "skill_routing_index",
    component: SkillRoutingView,
    meta: { permissions: [...ROLES] },
  },
  {
    path: frontendURL("accounts/:accountId/rbac-roles"),
    name: "rbac_roles_index",
    component: RolesView,
    meta: { permissions: [...ROLES] },
  },
];
